import { AmplitudeFlagKeys } from 'types/amplitudeFlags';

import useExperimentValue from 'components/Amplitude/useExperimentValue';

import { FeatureFlagVariants } from './variants';

const usePriceDisplayCadence = () => {
  const featureFlagVariant = useExperimentValue(
    AmplitudeFlagKeys.billingPayWallPlanSummaryPriceDisplayCadence
  ) as FeatureFlagVariants;

  return featureFlagVariant;
};

export default usePriceDisplayCadence;
